import { buscarPendiente, claveEscrutinio, encolar } from "./colaSincronizacion";
import { guardarCache, leerCache } from "./almacenLocal";
import { obtenerUsername } from "./sesion";

// Escrutinio sin conexión: lo digitado se guarda en la cola del equipo
// (uno por mesa) y, para poder reabrir la mesa sin señal, se guarda también
// la última copia leída del servidor.

const claveCache = (mesa) => `escrutinio:${obtenerUsername()}:${claveEscrutinio(mesa)}`;

export const guardarCopiaEscrutinio = (mesa, registro) => guardarCache(claveCache(mesa), registro);
export const leerCopiaEscrutinio = (mesa) => leerCache(claveCache(mesa));

export const buscarEscrutinioPendiente = (mesa) => buscarPendiente("escrutinio", claveEscrutinio(mesa));

// Convierte el pendiente al formato que devuelve el backend, para cargarlo
// en el formulario. "base" es la copia del servidor (si existía).
export const registroDesdePendiente = (pendiente, base = null) => {
  const { foto, ...datos } = pendiente.datos;
  const { cierre } = pendiente;
  return {
    ...(base ?? {}),
    ...datos,
    estado: cierre ? "cerrado" : base?.estado ?? "abierto",
    observacion: cierre ? cierre.observacion || null : base?.observacion ?? null,
    tieneProblema: cierre ? cierre.tieneProblema : base?.tieneProblema ?? false,
    reconteoSolicitadoPor: cierre ? cierre.reconteoSolicitadoPor || null : base?.reconteoSolicitadoPor ?? null,
    reconteoEnRepresentacionDe: cierre
      ? cierre.reconteoEnRepresentacionDe || null
      : base?.reconteoEnRepresentacionDe ?? null,
    tieneFoto: Boolean(foto) || Boolean(base?.tieneFoto),
    pendiente: true,
  };
};

// Guarda el acta en el equipo, fusionando con lo que ya estuviera en la cola
// (así una foto agregada después no borra los votos, y guardar sin foto nueva
// conserva la anterior). Con "cierre" queda marcada para cerrarse al enviar.
export const guardarEscrutinioEnEquipo = async (datos, cierre = null) => {
  const anterior = await buscarPendiente("escrutinio", claveEscrutinio(datos));
  const datosFinales = { ...(anterior?.datos ?? {}), ...datos };
  if (datosFinales.foto === undefined) delete datosFinales.foto;

  return encolar(
    "escrutinio",
    { datos: datosFinales, cierre: cierre ?? anterior?.cierre ?? null },
    claveEscrutinio(datos)
  );
};
